module.exports = __webpack_public_path__ + "static/D365-business-intelligence-b00eb63dd161307b101a3162755743eb.png";